import { css } from "@emotion/react";
import type { Theme } from "@emotion/react";

export const avatarWrapper = (theme: Theme) => css`
  margin-bottom: ${theme.ds5.spacing.gap.small};
`;
